<td>
  <web-components-instrument-details-link [isin]="etp.isin">
    {{ etp.description }}
  </web-components-instrument-details-link>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.staking-reward.label' | transloco }}
      <div class="icon-tooltip-wrapper">
        <svg class="icon icon-16 cursor-pointer" (click)="showStakingRewardModal.emit()">
          <use xlink:href="/assets/img/svgs/svgset.svg#info" />
        </svg>
      </div>
    </div>
    <div class="text-right">
      {{ etp.stakingReward | percent }}
    </div>
    @if (!etp.stakingReward) {
      <div class="text-right">&mdash;</div>
    }
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.wkn' | transloco }}
    </div>
    <div class="text-right">
      <div>
        {{ etp.wkn }}
      </div>
    </div>
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.quote' | transloco }}
    </div>
    @if (etp.ask) {
      @if (etp.ask && etp.ask < 50) {
        <div zeroBlink [val]="etp.ask">
          {{ etp.ask | currency: 'EUR' : 'symbol' : '1.3' }}
        </div>
      }
      @if (etp.ask >= 50) {
        <div zeroBlink [val]="etp.ask">
          {{ etp.ask | currency: 'EUR' : 'symbol' : '1.2' }}
        </div>
      }
    } @else {
      <div class="text-color-primary">&mdash;</div>
    }
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.perf' | transloco }}
    </div>
    @if (etp.percent >= 0 || etp.percent < 0) {
      <div [ngClass]="etp.percent >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
        {{ etp.percent >= 0 ? '+' : '' }}{{ etp.percent | number: '1.2-2' }} %
      </div>
    } @else {
      <div class="text-right">&mdash;</div>
    }
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.time' | transloco }}
    </div>
    @if (etp.quoteTime) {
      <div class="text-color-primary">
        {{ (etp.quoteTime | isQuoteOld) ? (etp.quoteTime | date: 'dd.MM.yy') : (etp.quoteTime | date: 'HH:mm:ss') }}
      </div>
    } @else {
      <div class="text-color-primary">&mdash;</div>
    }
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div
      class="trade savings-plan cursor-pointer"
      title="Sparplan anlegen"
      [routerLink]="commonRoutes.postlogin.add_savings_plan + '/' + etp.isin"
    >
      <svg class="icon icon-24">
        <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
      </svg>
    </div>
    <div
      class="trade buy cursor-pointer"
      title="Kaufen"
      [routerLink]="commonRoutes.postlogin.buyAndSell"
      [queryParams]="{
        isin: etp.isin,
        direction: 'buy',
      }"
    >
      K
    </div>
    <div
      class="trade sell cursor-pointer"
      title="Verkaufen"
      [routerLink]="commonRoutes.postlogin.buyAndSell"
      [queryParams]="{
        isin: etp.isin,
        direction: 'sell',
      }"
    >
      V
    </div>
  </div>
</td>
